module.exports = __webpack_public_path__ + "img/logo.adcd97bc.svg";